import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, HostListener } from '@angular/core';
import { QuestionComponent } from '../question/question.component';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionnaireService } from '../services/questionnaire.service';

@Component({
	selector: 'questions-manager',
	templateUrl: './questions-manager.component.html',
	styleUrls: ['./questions-manager.component.scss']
})
export class QuestionsManagerComponent implements OnInit {
	@Input() visibleQids: any; //array of visible questions or 'all' foll all questions visible

	@Input() editQid: any;
	@Output() editQidChange: EventEmitter<any> = new EventEmitter<any>();

	@Input() editQuestion: any;//deprecated
	@Output() editQuestionChange: EventEmitter<any> = new EventEmitter<any>();

	questions: any = {};//questions dictionary
	questionsArr: any = [];	//questions array
	lastScrollPosition;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public questionaryService: QuestionnaireService
	) {

	}

	ngOnInit() {
		this.lastScrollPosition = document.documentElement.scrollTop;
		console.log(">>>>>>>>>>>>>> QuestionsManagerComponent");
		window.scrollTo(0, 0);
		window.addEventListener('scroll', (evt) => {
			//console.debug("++++++++++++  evt=", evt);
			let isScrollUp = this.lastScrollPosition > document.documentElement.scrollTop;

			if (isScrollUp) {
				this.questionaryService.setScrollHintVisible(false);
			}

			this.lastScrollPosition = document.documentElement.scrollTop;
			//console.log('0000000000000000000000document.documentElement.scrollTop', document.documentElement.scrollTop);

		}, true);

	}

	ngOnChanges(changes: SimpleChanges) {
		let chng = changes["editQid"];

		console.log("=-------> ngOnChanges()", this.visibleQids);

		if (chng && chng.currentValue != chng.previousValue) {
			this.scrollIntoView(this.editQid);

			setTimeout(() => {//wait until scroll finish
				this.setScrollHint(chng.currentValue);
			}, 500);

		}



	}

	setScrollHint(qID) {
		this.questions;
		this.visibleQids;

		let visibleQidDic = {};

		this.visibleQids.forEach(q => {
			visibleQidDic[q] = true;
		});

		let visibleQidOrdered = this.questionsArr.filter(q => visibleQidDic[q.qID]);

		//return visibleQidOrdered;

		let isNotVisibleQuestion = !(visibleQidDic[qID]);
		let isLastVisibleQuestion = (visibleQidOrdered.length)?(visibleQidOrdered[visibleQidOrdered.length - 1].qID === qID):false;
		let isHasScroll = (document.documentElement.scrollTop > 50);

		if (isHasScroll && (isNotVisibleQuestion || isLastVisibleQuestion)) {
			//show scroll hint
			this.questionaryService.setScrollHintVisible(true);
			//console.debug(">>> setScrollHintVisible(true):", document.documentElement.scrollTop);
		} else {
			//dont show scroll hint
			console.debug(">>>> setScrollHintVisible(false):", document.documentElement.scrollTop);
			//this.questionaryService.setScrollHintVisible(false);
		}
	}

	scrollIntoView(qid: any) {
		setTimeout(() => {    //<<<---    using ()=> syntax
			// activeQuestion.elemRef.nativeElement.scrollIntoView({
			// 	behavior: "smooth"
			// 	//block:"start"				
			// });

			let isMdUp = window.innerWidth>768//'mobile'

			let topPad = (isMdUp) ? 280:120;

			let elTop = (this.questions)? (this.questions[qid]?(this.questions[qid].elemRef.nativeElement.offsetTop - topPad):930):930;//top pad for offsetting fixed header
								

			//smooth scroll
			window.scroll({
				top: elTop, 
				//left: 0, 
				behavior: 'smooth' 
			});

			setTimeout(()=>{//scroll fallback if smooth scroll not working
				if(window.pageYOffset==0){
					window.scroll(0,elTop);
				}
			},200)					
		}, 300);
	}
	

	//question component add itself to questions array
	addQuestion(question: QuestionComponent) {
		if (this.questions[question.qID] === undefined) {
			this.questions[question.qID] = question;
			this.questionsArr.push(question);
		} else {
			console.error("qID ", question.qID, "already exsist!");
		}
	}

	isVisible(qID): boolean {
		if (this.editQid === qID) {
			return true;
		} else if (this.visibleQids === "all") {
			return true;
		} else if (this.visibleQids) {
			return (this.visibleQids.indexOf(qID) > -1);
		} else {
			return false;
		}
	}

	setEditQuestion(qID) {
		this.editQuestion = qID;
		this.editQid = qID;

		this.router.navigate(["../", "all"], { relativeTo: this.route }).then(//
			res => {
				//this.router.navigate(["questionnaire",,{relativeTo:this.route}]);
				this.editQuestionChange.emit(qID);
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/questions-manager/questions-manager.component.ts